import { AnyAction } from "redux";
import { PaginationPartyBalance } from "../../generated/graphql";
import { LOGOUT_ACTION } from "../action/auth.action";
import { LEDGER_SUCCESS } from "../action/ledger.action";

export const ledgerReducers = (
  state: {
    ledgerBalance: PaginationPartyBalance | null;
  } = {
    ledgerBalance: null,
  },
  action: AnyAction,
) => {
  switch (action.type) {
    case LEDGER_SUCCESS:
      return { ...state, ledgerBalance: { ...action.payload } };

    case LOGOUT_ACTION:
      return { ...state, ledgerBalance: null };

    default:
      return state;
  }
};
